<ds-thumbnail *ngIf="(initialized | async)"
              [thumbnail]="bitstream$ | async"
              [defaultImage]="default">
</ds-thumbnail>
